import { render, staticRenderFns } from "./IconCloseCircleLg.vue?vue&type=template&id=dcec34a6&"
import script from "./IconCloseCircleLg.vue?vue&type=script&lang=js&"
export * from "./IconCloseCircleLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcec34a6')) {
      api.createRecord('dcec34a6', component.options)
    } else {
      api.reload('dcec34a6', component.options)
    }
    module.hot.accept("./IconCloseCircleLg.vue?vue&type=template&id=dcec34a6&", function () {
      api.rerender('dcec34a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCloseCircleLg.vue"
export default component.exports